import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import ProductNav from '../../common/ProductNav';
import { tabsValues } from '../../config/pageConfig';
import AnimationA from './components/AnimationA';
import Banner from './components/Banner';
import LightestProduct from './components/LightestProduct';
import SenceCard from './components/SenceCard';
import SenceResolve from './components/SenceResolve';
import KSPPicture from './components/KSPPicture';
import DisasterPrevention from './components/DisasterPrevention';
import UsageScenarios from './components/UsageScenarios';
import FooterTcA from './components/FooterTcA';
import LightestUsedSence from './components/LightestUsedSence';
import SecurityProtection from './components/SecurityProtection';
import FullPowerTrigger from './components/FullPowerTrigger';
import SenceCardB from './components/SenceCardB';
import SenceCardC from './components/SenceCardC';
import SenceCardD from './components/SenceCardD';
import SenceCardE from './components/SenceCardE';
import PageNavLeft, { Theme } from './components/PageNavLeft';
import gtm from '@/utils/gtm';
import { useLang } from '@/i18n';

export default function StatusItem() {
    const [isClient, setIsClient] = useState(false);
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const { t } = useLang('Delta3AirStation.KSP');
    const { query } = useRouter();
    const searchTab = query?.tab;
    let defaultTab = 'Product';
    if (typeof searchTab === 'string' && tabsValues.includes(searchTab)) {
        defaultTab = searchTab;
    }
    const [activeTab, setActiveTab] = useState(defaultTab);
    const tabCallback = (tabValue: string) => {
        setActiveTab(tabValue);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <ProductNav activeTab={activeTab} />
            {activeTab === 'Product' && (
                <section className="ecoflow-d3a-air-page">
                    <AnimationA />
                    <LightestProduct />
                    {/* <SenceResolve /> */}
                    <KSPPicture />
                    <LightestUsedSence />
                    <SecurityProtection />
                    <FullPowerTrigger />
                    <SenceCardB />
                    <SenceCardC />
                    <SenceCardD />
                    <SenceCardE />
                    <UsageScenarios />
                    <DisasterPrevention />
                    <PageNavLeft
                        triggerElement=".ecoflow-d3a-air-page"
                        enterElement="#List-sence-A"
                        steps={
                            [
                                { text: t('item1'), href: '#List-sence-A' },
                                { text: t('item2'), href: '#List-sence-B' },
                                { text: t('item3'), href: '#List-sence-C' },
                                { text: t('item4'), href: '#List-sence-D' },
                                { text: t('item5'), href: '#List-sence-E' },
                                { text: t('item6'), href: '#List-sence-F' },
                                { text: t('item7'), href: '#List-sence-G' },
                            ].filter(Boolean) as any
                        }
                    />
                    <FooterTcA />
                </section>
            )}
            {/* {activeTab === 'Bundles' && (
                <>
                    <Bundles addShopCartCallback={handleAddToCart} />
                </>
            )} */}
        </>
    );
}
